import { render, staticRenderFns } from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=template&id=303ddf5a&scoped=true"
import script from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=script&lang=ts"
export * from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ddf5a",
  null
  
)

export default component.exports